import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DatasourceService = /** @class */ (function () {
    function DatasourceService(http) {
        this.http = http;
        this.deepConfigEndPoint = '/dashboard/deepconfig/';
        this.moduleEndPoint = '/dashboard/module/';
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    DatasourceService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    // Module Methods
    DatasourceService.prototype.getModuleList = function (data) {
        var endPoint = this.moduleEndPoint + 'list';
        var dataToSend = {
            'params': data
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    DatasourceService.prototype.getModuleDetails = function (appId, moduleId) {
        var endPoint = this.moduleEndPoint + appId + '/' + moduleId;
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions)).pipe(map(this.extractData));
    };
    DatasourceService.prototype.getModuleListByFilters = function (app_id, offset, limit, query) {
        var params = {
            'app_id': app_id,
            'offset': offset,
            'limit': limit
        };
        if (query) {
            params['q'] = query;
        }
        return this.getModuleList(params);
    };
    DatasourceService.prototype.createModule = function (params) {
        return this.http.post(this.moduleEndPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.createModuleByParams = function (name, desc, deepconfig_ids, app_id) {
        var params = {
            'name': name,
            'deepconfig_ids': deepconfig_ids,
            'desc': desc,
            'app_id': app_id
        };
        return this.createModule(params);
    };
    DatasourceService.prototype.updateModule = function (moduleId, name, desc, deepconfig_ids, app_id) {
        var endPoint = this.moduleEndPoint + moduleId;
        var params = {
            'name': name,
            'desc': desc,
            'deepconfig_ids': deepconfig_ids,
            'app_id': app_id
        };
        return this.http.put(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.deleteModule = function (appId, moduleId) {
        var endPoint = this.moduleEndPoint + appId + '/' + moduleId;
        return this.http.delete(endPoint, this.httpOptions).pipe(map(this.extractData));
    };
    // Deep config methods
    DatasourceService.prototype.getOrphanDeepConfigCount = function (appId, data) {
        var endPoint = this.deepConfigEndPoint + appId + '/orphandeepconfigcount';
        var dataToSend = {
            'params': data
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    DatasourceService.prototype.createDeepConfig = function (data) {
        var params = data;
        return this.http.post(this.deepConfigEndPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.createDeepConfigByParams = function (key, type, app_id, details, desc, is_active, module_id) {
        var params = {
            'key': key,
            'type': type,
            'app_id': app_id,
            'details': details,
            'desc': desc,
            'is_active': is_active
        };
        if (module_id) {
            params['module_id'] = module_id;
        }
        return this.createDeepConfig(params);
    };
    DatasourceService.prototype.updateDeepConfig = function (deepConfigId, key, type, app_id, details, desc, is_active, module_id) {
        var endPoint = this.deepConfigEndPoint + deepConfigId;
        var params = {
            'key': key,
            'type': type,
            'app_id': app_id,
            'details': details,
            'desc': desc,
            'is_active': is_active
        };
        if (module_id) {
            params['module_id'] = module_id;
        }
        return this.http.put(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.attachDeepConfigsToModule = function (appId, deepConfigList, moduleId) {
        var endPoint = this.moduleEndPoint + moduleId + '/attach';
        var params = {
            'app_id': appId,
            'deepconfig_ids': deepConfigList
        };
        return this.http.put(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.detachDeepConfigsFromModule = function (appId, deepConfigList, moduleId) {
        var endPoint = this.moduleEndPoint + moduleId + '/detach';
        var params = {
            'app_id': appId,
            'deepconfig_ids': deepConfigList
        };
        return this.http.put(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.deleteDeepConfig = function (deepConfigId, appId) {
        // const endPoint = this.deepConfigEndPoint + appId + '/' + deepConfigId;
        var endPoint = this.deepConfigEndPoint + deepConfigId;
        return this.http.delete(endPoint, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.getDeepConfigList = function (data) {
        var endPoint = this.deepConfigEndPoint + 'list';
        var dataToSend = {
            'params': data
        };
        return this.http.get(endPoint, tslib_1.__assign({}, this.httpOptions, dataToSend)).pipe(map(this.extractData));
    };
    DatasourceService.prototype.getDeepConfigListByFilters = function (isOrphan, offset, limit, appId, query, type, status, moduleIdList) {
        var params = {
            'app_id': appId,
            'offset': offset,
            'limit': limit,
            'orphan': isOrphan
        };
        if (query) {
            params['q'] = query;
        }
        if (type) {
            params['type'] = type;
        }
        if (status) {
            params['status'] = status;
        }
        if (moduleIdList) {
            params['module_ids'] = moduleIdList;
        }
        return this.getDeepConfigList(params);
    };
    DatasourceService.prototype.getDeepConfigListById = function (appId, idList) {
        var params = {
            'app_ids': [appId],
            'ids': idList
        };
        return this.getDeepConfigList(params);
    };
    DatasourceService.prototype.getDeepConfigListByModule = function (appId, moduleId) {
        var params = {
            'app_ids': [appId],
            'module_id': moduleId
        };
        return this.getDeepConfigList(params);
    };
    DatasourceService.prototype.getDeepConfigDetails = function (appId, deepConfigId) {
        var endPoint = this.deepConfigEndPoint + appId + '/' + deepConfigId;
        return this.http.get(endPoint, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.uploadLocaleFile = function () { };
    DatasourceService.prototype.uploadImage = function () { };
    DatasourceService.prototype.downloadLocaleFile = function (file_id) {
        var endPoint = this.deepConfigEndPoint + 'downloadlocale/' + file_id;
        return this.http.get(endPoint, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.copyLocaleFile = function (file_id, app_id) {
        var endPoint = this.deepConfigEndPoint + 'copylocale';
        var params = {
            'file_id': file_id,
            'app_id': app_id
        };
        return this.http.post(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.bulkUpdateDeepConfig = function (updatedDeepConfigs, moduleId) {
        var endPoint = this.deepConfigEndPoint + 'update/';
        updatedDeepConfigs.module_id = moduleId;
        return this.http.post(endPoint, updatedDeepConfigs, this.httpOptions).pipe(map(this.extractData));
    };
    DatasourceService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            // TODO: better job of transforming error for user consumption
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    DatasourceService.prototype.getLocaleList = function (appId) {
        var url = 'dashboard/locale/list?app_id=' + appId;
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    DatasourceService.ngInjectableDef = i0.defineInjectable({ factory: function DatasourceService_Factory() { return new DatasourceService(i0.inject(i1.HttpClient)); }, token: DatasourceService, providedIn: "root" });
    return DatasourceService;
}());
export { DatasourceService };
